export default "__VITE_ASSET__53af93dd__"